import { combineReducers } from 'redux'
import chat from './chat'

const aiReducer = combineReducers({
  chat,
})

export default aiReducer
